<template>
    <div
        class="file-selector row items-center justify-center"
        :class="{ hover: dropZoneHover }"
        @dragover.prevent="dropZoneHover = true"
        @dragleave.prevent="dropZoneHover = false"
        @drop.prevent="handleDrop"
    >
        <div class="q-mr-sm">
            <q-icon :name="icon ?? 'fa-light fa-cloud-arrow-up default-grey-icon-color'" :size="iconSize ?? '48px'" />
        </div>
        <template v-if="label"> </template>
        <template v-else>
            <div>
                <span class="medium-text-color">{{ $t("shared.Drop file here") }}</span>
                <br />
                <span class="medium-text-color">{{ $t("shared.or") }}</span>
                <br />
                <span class="text-link">{{ $t("shared.Choose file") }}</span>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

interface FileSelectorProps {
    label?: string;
    icon?: string;
    iconSize?: string;
}

defineProps<FileSelectorProps>();
const emits = defineEmits<{ onFileDragged: [file: File] }>();

const dropZoneHover = ref(false);

const handleDrop = (e: DragEvent) => {
    const files = e.dataTransfer?.files;
    if (!files || Array.from(files).length === 0) return;

    emits("onFileDragged", files[0]);
};
</script>

<style lang="scss" scoped>
.file-selector {
    cursor: pointer;
    width: 100%;
    height: 100%;
}
.hover {
    background: $grey-95;
}
.text-link {
    text-decoration: underline;
}
</style>
